import axios from 'axios';
import _ from 'lodash';
import { storeKey } from 'vuex';
import { useCurrentUserStore } from '../../pinia/CurrentUserStore';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    internal : {
        companies : [],
        user_company: 0,
        user : {}
      },
      print_view : false,
      useredit : false,
    url : null,
    pagination : 0,
    sidebar : {
      minimize: false,
    },
    isSaving : false
})

  // getters
  const getters = {
    getActiveCompany: state => () => {
      try{
        const currentUser = useCurrentUserStore();

        var index = state.internal.companies.findIndex(item => item.id == state.internal.user_company);
        currentUser.company_data = state.internal.companies[index];
        if(state.internal.companies[index].settings && state.internal.companies[index].settings.date_timezone){
          currentUser.current_timezone = state.internal.companies[index].settings.date_timezone
        }
        return state.internal.companies[index];
      }catch(e){
        return {};
      }
    }
  }

  // actions
  const actions = {
    async updateMyUser({commit, state}, data){
      commit("isSaving", true);
      let response = axios.put(state.url + "/api/v1/user/profile", data).then((response) => {
        commit("setUser", response.data.data);
        return response.data.data;
      })
      commit("isSaving", false);
      return response;
    }
  }

  // mutations
  const mutations = {
      baseUrl(state, url){
          state.url = url;
      },
      setPrintView(state, status){
        state.print_view = status;
      },
    companies(state, companies){
        state.internal.companies = companies;
    },
    internalUserCompanyChange(state, company) {
      const currentUser = useCurrentUserStore();
      currentUser.internal_company = company;
      var index = state.internal.companies.findIndex(item => item.id == company);
        if(index > -1){
          currentUser.company_data = state.internal.companies[index];
          if(state.internal.companies[index].settings && state.internal.companies[index].settings.date_timezone){
            currentUser.current_timezone = state.internal.companies[index].settings.date_timezone
          }
        }else{
          currentUser.company_data = {};
        }
        state.internal.user_company = company;
    },
    setUser(state, user){
      state.internal.user = user;
    },
    useredit(state, status){
        state.useredit = status;
    },
    setKey(state, data){
        if(_.has(state, data.key)){
            _.set(state, data.key, data.value);
        }
    },
    isSaving(state, status) {
      state.isSaving = status;
    },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
